import {Counter as PeacockCounter} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ICounter} CounterProps
 * @property {string | number} [value] Current value of the counter. Defaults to 0.
 * @property {(value: string | number) => void} [onUpdate] Callback triggered when value changes.
 * @property {number} [minValue] Minimum value.
 * @property {number} [maxValue] Maximum value.
 * @property {'medium' | 'small'} [size] Counter size. Defaults to medium.
 * @property {boolean} [disabled] When true, counter is disabled.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {boolean} [error] When true, renders error state.
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] Label configuration.
 * @property {string | import('react').ReactNode} [helperText] Helper text shown below the counter.
 * @property {boolean} [required] When true, marks the counter as required.
 * @property {boolean} [optional] When true, marks the counter as optional.
 * @property {'naked' | 'default'} [type] Counter visual type. Defaults to default.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Counter.
 * Supports all Peacock DS counter props.
 * @param {CounterProps} props
 */
export const Counter = props => {
  return <PeacockCounter {...props} />
}
